

























































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteMotivosCancelamentoStore from '@/components/Suporte/Store/SuporteMotivosCancelamentoStore'
import _ from 'lodash'
import { useHospitais } from '@/composables'

@Component
export default class ViewSuporteMotivoCancelamento extends Vue {
  loadMotivosCancelamento: boolean = false
  loadEditMotivoCancelamento: string = ''

  get getSuporteMotivosCancelamentoStore() {
    return getModule(SuporteMotivosCancelamentoStore, this.$store)
  }

  get loadingMotivosCancelamento() { return this.loadMotivosCancelamento }
  set loadingMotivosCancelamento(value: boolean) { this.loadMotivosCancelamento = value }
  get loadingEditMotivoCancelamento() { return this.loadEditMotivoCancelamento }
  set loadingEditMotivoCancelamento(value: string) { this.loadEditMotivoCancelamento = value }

  get hospitalId() { return this.getSuporteMotivosCancelamentoStore.hospitalId }
  set hospitalId(value: string) { this.getSuporteMotivosCancelamentoStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get motivosCancelamentoHeaders() {
    return [
      { text: 'Descrição', value: 'descricao', sortable: false },
      { text: 'HisId', value: 'hisId', sortable: false },
      { text: 'HisTipo', value: 'hisTipo', sortable: false },
      { text: 'Medico pode visualizar?', value: 'medicoVisualizar', align: 'center', sortable: false },
      { text: 'Etapa', value: 'etapa', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get motivosCancelamento() { return this.getSuporteMotivosCancelamentoStore.motivosCancelamento }
  get searchMotivoCancelamento() { return this.getSuporteMotivosCancelamentoStore.searchMotivoCancelamento }
  set searchMotivoCancelamento(value: string) { this.getSuporteMotivosCancelamentoStore.setSearchMotivoCancelamento(value) }

  async hospitalChange(id: any) {
    this.getSuporteMotivosCancelamentoStore.clearSearchMotivoCancelamento()
    this.getSuporteMotivosCancelamentoStore.setHospitalId(id)

    this.loadingMotivosCancelamento = true
    await this.getSuporteMotivosCancelamentoStore.getMotivosCancelamentoByHospitalId()
    this.loadingMotivosCancelamento = false
  }

  adicionarMotivoCancelamento() {
    this.getSuporteMotivosCancelamentoStore.setMode({ modal: 'motivoCancelamento', mode: 'CREATE' })
    this.getSuporteMotivosCancelamentoStore.clearMotivoCancelamento()
    this.getSuporteMotivosCancelamentoStore.setModal({ name: 'motivoCancelamento', value: true })
  }

  async editarMotivoCancelamento(item: any) {
    this.loadingEditMotivoCancelamento = item.id
    this.getSuporteMotivosCancelamentoStore.setMode({ modal: 'motivoCancelamento', mode: 'EDIT' })
    this.getSuporteMotivosCancelamentoStore.setMotivoCancelamento({ ...item })
    this.getSuporteMotivosCancelamentoStore.setModal({ name: 'motivoCancelamento', value: true })
    this.loadingEditMotivoCancelamento = ''
  }

  beforeDestroy() {
    this.getSuporteMotivosCancelamentoStore.clearMotivosCancelamento()
    this.getSuporteMotivosCancelamentoStore.clearHospitalId()
  }
}
